import { apiInstance } from '../api';

const route = '/residentialComplexBuild/admin';

// the admin panel's checkerboard editor (express controllers/residentialComplexBuild/editor.js)
export class CheckerboardService {
  // { complex, queues: [{ id, name, endingperiod, eciOldId, flats, buildings: [{ id, number, eciOldId, flats, sections }] }] }
  static async fetchStructure(complexId) {
    return apiInstance.get(`${route}/structure/${complexId}`)
  }

  // the board of one building: sections with stands and their flats
  static async fetchBoard(buildingId) {
    return apiInstance.get(`/residentialComplexBuild/chessTable/${buildingId}`)
  }

  static async save(kind, id, values) {
    return id ? apiInstance.put(`${route}/${kind}/${id}`, values) : apiInstance.post(`${route}/${kind}`, values)
  }

  // «Добавить корпус на старом сайте»: { queueId, number, deadline } → { building, queueId } or { dry, message }
  static async createOnOld(values) {
    return apiInstance.post(`${route}/building-on-old`, values)
  }

  static async remove(kind, id) {
    return apiInstance.delete(`${route}/${kind}/${id}`)
  }

  static async renameStand(sectionId, apartmentIds, label) {
    return apiInstance.put(`${route}/stand`, { sectionId, apartmentIds, label })
  }
}
